module.exports = __webpack_public_path__ + "static/media/dockin_logo_new.39320bd1.png";